/**
 * @description Wrapper around Google Places autocomplete widget and SmartyStreet api for address verification
 *
 * @param token SmartyStreet client side api token
 * @param geocoded Model in the form {street,street2,city,state,zip} additionally needApt and error are added if a street2 is needed or there are network problems repectively
 * @param inputClass Extra classes to be added to the input element
 * @param tabIndex Tab index of input element
 * @param inputPlaceholder Placeholder text
 * @param inputId Id attribute of input element
 * @param onEvent Fired when a address is selected
 * @param ignoreValidation Used to bypass strict address validation from SmartyStreet and google, Google must still return an address is just does not have to be marked as a premise
 * @param ignoreSmartyStreet Used to bypass SmartyStreet
 **/
window.angular.module('hippoComponents').run(function ($window) {
    'ngInject';
    if (typeof $window.googleCallback === 'undefined') {
        $window.googleCallback = function () {
            if ($window.googleCallbackDefer) {
                $window.googleCallbackDefer.resolve();
            }
        };

        const s = $window.document.createElement('script');
        s.setAttribute('type', 'text/javascript');
        s.setAttribute(
            'src',
            `https://maps.googleapis.com/maps/api/js?key=${$window.hippoConfig.GOOGLE_MAPS_API_KEY}&libraries=places&callback=googleCallback`
        );
        s.setAttribute('async', 'defer');
        $window.document.body.appendChild(s);
    }
});

window.angular.module('hippoComponents').directive('deepLiveaddress', function ($http, $q, $timeout, $window) {
    'ngInject';
    return {
        restrict: 'E',
        template: `
      <div class="liveaddress hide-apt deep-field" ng-model="liveAddressValue" name="liveAddressValue" ng-class="{'hide-apt':!showApt && !needApt(), 'mdl-textfield mdl-js-textfield mdl-textfield--floating-label text-input':field.mdlTextField}">
        <input type="text" autocapitalize="off" autocorrect="off" maxlength="100" ng-model="address" id="{{::field.deepKey}}" tabindex="{{ tabIndex }}" class="input-street {{ field.inputClass }}" placeholder="{{ field.placeholder }}" />
        <button type="button" ng-if="address" class="clear-input" ng-click="clearInput($event)"><span class="hippo-icon-clear-input" alt="clear input"></button>
        <div class="apt-field">
          <input type="text" autocapitalize="off" autocorrect="off" maxlength="8" ng-model="street2" id="{{::field.deepKey + 'street2'}}" class="input-street2 mdl-textfield__input" placeholder="Unit #" />
          <div class="mdl-textfield__label"></div>
        </div>
        <field-error class="error-message show" field="{deepKey: 'liveAddressValue', requiredError: 'Address Required'}"></field-error>
      </div>
      <p class="caption" ng-if="field.caption">{{field.caption}}</p>
`,
        scope: {
            data: '<',
            field: '<',
            onEvent: '&'
        },
        link: function (scope, element) {
            const { componentHandler, _ } = window;
            const $scope = scope; // support both.
            let autocomplete;
            let autocompleteLsr;

            let lastSmartyStreetsResult = {};

            // HIP-2346 - distinguish between if place was selected from list or ENTER was typed.
            // if ENTER - we don't want to combine Google results
            // if Selected - we DO want to combine Google results
            const DROPDOWN_CLICK_ORIGIN = 'dropdown_click'; // the user chose it from the list using mouse
            const DROPDOWN_KEYBOARD_ORIGIN = 'dropdown_keyboard'; // the user chose it from the list using keyboard
            const TEXT_ORIGIN = 'text_input'; // the user typed it in
            let origin = null;

            const ngModelCtrl = element.children().first().controller('ngModel');

            /**
             *
             * @param {boolean} isValid - should be true only if not pending
             */
            function setPendingValidationValidity(isValid) {
                if (!$scope.field.ignoreValidation) {
                    ngModelCtrl.$setValidity('liveaddressPending', isValid);
                }
            }
            const getSmartyToken = () => {
                if (_.isArray(window.hippoConfig.configuration.lead_smarty_streets_key)) {
                    return window.hippoConfig.configuration.lead_smarty_streets_key[
                        _.random(0, window.hippoConfig.configuration.lead_smarty_streets_key.length - 1)
                    ];
                }
                return window.hippoConfig.configuration.lead_smarty_streets_key;
            };

            $scope.token = getSmartyToken();
            function needApt() {
                return (
                    lastSmartyStreetsResult &&
                    lastSmartyStreetsResult.analysis &&
                    (lastSmartyStreetsResult.analysis.dpv_match_code === 'D' ||
                        lastSmartyStreetsResult.analysis.dpv_match_code === 'S')
                );
            }
            function alreadyGotApt() {
                return !_.isEmpty($scope.street2);
            }
            $scope.needApt = needApt;

            $scope.liveAddressValue = {
                street: '',
                city: '',
                state: ''
            };

            scope.clearing = false;
            scope.blurring = false;

            scope.clearInput = function (e) {
                if (needApt() && scope.street2) {
                    scope.street2 = '';
                } else {
                    scope.address = '';
                    scope.geocoded = undefined;
                    scope.liveAddressValue = {};
                    scope.street2 = undefined;
                    scope.clearing = true;
                    lastSmartyStreetsResult = null;
                    setPendingValidationValidity(false);
                    scope.sendEvent();
                    clear();
                    element.find('input')[0].focus();
                    e.preventDefault();
                    e.stopPropagation();
                }
            };

            /**
             *
             * @description
             * sends event for change.
             *
             * if ignoreValidation is false, will wait for validation to be completed
             *
             * validation is completed if 'validated' is true or false.
             * validation is not completed if 'validated' is undefined.
             *
             * @param value - the address
             * @param {boolean|undefined|null} [validated] - whether it was validated by google and smartstreets
             */
            scope.sendEvent = function (value, validated = null) {
                if (typeof scope.onEvent === 'function') {
                    scope.onEvent({
                        $event: {
                            eventType: 'change',
                            parameters: { value, validated },
                            field: scope.field
                        }
                    });
                }
            };

            $scope.sendInStreet = function (placeStr) {
                $scope.liveAddressValue = {
                    street: placeStr, // THESE TWO EMPTY STRINGS ARE IMPORTANT. SEE HIP-2532
                    street2: '',
                    city: ''
                };
                scope.sendEvent($scope.liveAddressValue);
            };

            const clear = function () {
                element.find('input')[0].value = '';
            };

            const allEmptyStrings = (val) => {
                if (_.isObject(val)) {
                    let ret = true;
                    _.forEach(val, function (item) {
                        if (_.isString(item) && item.trim() !== '') {
                            ret = false;
                        }
                    });
                    return ret;
                }
                return false;
            };

            function focusOnApt() {
                element.find('input')[1].focus();
            }

            element.find('input')[0].addEventListener('blur', function (e) {
                scope.blurring = true;
            });

            // this is changes in HIP-409 to add the ', ' on if you are adding something after it
            // this is for the situation where google was not able to parse the address and so the
            // whole thing is passed into street, the old method would have resulted in 1532 Carlton Road, Undefined
            // we also check if a google item is selected and ignore the change if the user is selecting something from the list
            scope.$watch(`data.${$scope.field.deepKey}`, function (value) {
                if (typeof value === 'undefined' || allEmptyStrings(value)) {
                    if (scope.address && scope.address.length > 0) {
                        // address field is not empty, but is invalid
                        ngModelCtrl.$setValidity('address', false);
                    } else {
                        ngModelCtrl.$setValidity('required', false);
                    }
                } else if (
                    typeof value === 'object' &&
                    value !== null &&
                    value.street &&
                    $window.$('.pac-item-selected').length === 0 &&
                    !value.invalid
                ) {
                    const tmpAddress = convertHippoAddressToString(value);
                    scope.address = tmpAddress.address;
                    scope.street2 = tmpAddress.street2;
                    if (scope.street2) {
                        scope.showApt = true;
                    }

                    if (scope.field.ignoreValidation === true) {
                        ngModelCtrl.$setValidity('required', true);
                        ngModelCtrl.$setValidity('address', true);
                        setPendingValidationValidity(true);
                    }
                } else {
                    ngModelCtrl.$setValidity('address', false);
                }
            });

            scope.$watch('field.showApt', function (value) {
                if (value) {
                    scope.showApt = true;
                }
            });

            scope.$watch('needApt()', function (newValue, oldValue) {
                if (newValue === true && newValue !== oldValue) {
                    focusOnApt();
                }
            });

            scope.$watch('street2', function (value) {
                ngModelCtrl.$setValidity('needApt', !needApt() || alreadyGotApt()); // TODO: find a better place for this
            });

            const convertHippoAddressToString = function (value) {
                const ret = { address: '', street2: '' };
                // Remove ', United States' from the address
                if (_.endsWith(value.street, ', United States')) {
                    ret.address = value.street.substring(0, value.street.indexOf(', United States'));
                } else {
                    ret.address = value.street;
                }

                if (value.street2 && value.street2 !== '') {
                    ret.street2 = value.street2;
                }
                if (value.city) {
                    ret.address += ', ' + value.city;
                }
                if (value.state) {
                    ret.address += ', ' + value.state.toUpperCase();
                }
                return ret;
            };

            const pullAddressFromGoogleFormat = function (place) {
                const componentForm = {
                    street_number: 'short_name',
                    subpremise: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    country: 'long_name',
                    postal_code: 'short_name'
                };

                const addressParams = {};

                if (place.address_components) {
                    for (let i = 0; i < place.address_components.length; i++) {
                        const addressType = place.address_components[i].types[0];
                        if (componentForm[addressType]) {
                            addressParams[addressType] = place.address_components[i][componentForm[addressType]];
                        }
                    }
                }
                return addressParams;
            };

            function manualAddressOnly(splitAddress) {
                scope.liveAddressValue = {
                    street: splitAddress[0] || '',
                    street2: '',
                    city: splitAddress[1] || '',
                    state: splitAddress[2] || '',
                    zip: ''
                };
                const city = scope.liveAddressValue.city.trim();
                if (city.match(/[a-zA-Z]{2} [0-9]{5}/)) {
                    scope.liveAddressValue.state = city.substr(0, 2);
                    scope.liveAddressValue.zip = city.substr(3, 5);
                    scope.liveAddressValue.city = '';
                }
            }

            function combinePartialWithGoogle(splitAddress, addressObj, lookupFromPartialText) {
                scope.liveAddressValue = {
                    street: (addressObj.street_number ? addressObj.street_number : '') + ' ' + addressObj.route,
                    street2: addressObj.subpremise || '',
                    city: addressObj.locality,
                    // google returns address as Juanita Ave, San Jose, CA 95125, USA so the "CA 95125" needs a substr(0,2)
                    state: addressObj.administrative_area_level_1.toLowerCase(),
                    zip: addressObj.postal_code
                };
                if (lookupFromPartialText) {
                    // if the user typed in some text and hit enter defer to what they typed in rather than whatever google set
                    // as in this scenario google has been unreliable in the past. If a google address was selected from the dropdown
                    // i.e. lookupFromPartialText is false then ignore this
                    scope.liveAddressValue.street = splitAddress[0] || scope.liveAddressValue.street;
                    scope.liveAddressValue.city = splitAddress[1] || scope.liveAddressValue.city;
                    scope.liveAddressValue.state = splitAddress[2] || scope.liveAddressValue.state;
                }
            }

            function partialAddress(addressStr, addressObj, lookupFromPartialText) {
                const splitAddress = (addressStr || '').split(',');
                if ($scope.field.partialUseManualOnly && origin === TEXT_ORIGIN) {
                    manualAddressOnly(splitAddress);
                } else {
                    combinePartialWithGoogle(splitAddress, addressObj, lookupFromPartialText);
                }

                if (scope.liveAddressValue.street) {
                    scope.liveAddressValue.street = scope.liveAddressValue.street
                        .replace(/\b\w/g, (l) => l.toUpperCase())
                        .trim();
                }
                if (scope.liveAddressValue.city) {
                    scope.liveAddressValue.city = scope.liveAddressValue.city
                        .replace(/\b\w/g, (l) => l.toUpperCase())
                        .trim();
                }
                if (scope.liveAddressValue.state) {
                    scope.liveAddressValue.state = scope.liveAddressValue.state.trim().toLowerCase().substr(0, 2);
                }
                setPendingValidationValidity(true); // not waiting for further validations
                scope.sendEvent(scope.liveAddressValue, false); // not validated by smart streets
            }

            const isStatusOk = (status) => status === $window.google.maps.GeocoderStatus.OK;

            function convertStreetToPlace(str, lookupFromPartialText) {
                return $q((resolve, reject) => {
                    const geocoder = new $window.google.maps.Geocoder();
                    geocoder.geocode({ address: str }, (results, status) => {
                        if (lookupFromPartialText && results[0]) {
                            results[0].lookupFromPartialText = true;
                        }
                        isStatusOk(status) ? resolve(results[0]) : reject();
                    });
                });
            }

            function googlePlaceToSmartStreetsParams(place) {
                const addressParams = pullAddressFromGoogleFormat(place);
                const params = {
                    'auth-token': scope.token
                };
                if (place.address_components) {
                    params.street = addressParams.street_number + ' ' + addressParams.route;
                    params.city = addressParams.locality;
                    params.state = addressParams.administrative_area_level_1;
                } else if (place.name) {
                    [params.street, params.city, params.state] = place.name.split(',');
                }
                if (params.state) {
                    params.state = params.state.trim().toLowerCase().substr(0, 2);
                }
                return params;
            }

            function getSmartyStreetsResult(smartyStreetsParams) {
                const params = _.merge(smartyStreetsParams, {
                    license: 'us-rooftop-geocoding-enterprise-cloud',
                    match: 'enhanced'
                });
                return $http({
                    method: 'GET',
                    url: 'https://us-street.api.smartystreets.com/street-address',
                    params
                })
                    .then(
                        function (response) {
                            return _.merge({ components: {} }, response.data[0]);
                        },
                        function () {
                            return { components: {} };
                        }
                    )
                    .then((result) => {
                        lastSmartyStreetsResult = result;
                        return result;
                    });
            }

            function combineGoogleAndSmartStreets(google, smarty) {
                return {
                    street: `${google.street_number || smarty.delivery_line_1 || ''} ${google.route || ''}`.trim(),
                    street2: `${scope.street2 || google.subpremise || ''}`,
                    city: `${google.locality || smarty.components.city_name || ''}`,
                    state: `${
                        google.administrative_area_level_1 || smarty.components.state_abbreviation || ''
                    }`.toLowerCase(),
                    zip: `${google.postal_code || smarty.components.zipcode || ''}`
                };
            }

            /**
             *
             * @param googlePlace - google format */
            function addSmartyStreets(googlePlace, lookupFromPartialText) {
                const smartyParams = googlePlaceToSmartStreetsParams(googlePlace);
                getSmartyStreetsResult(smartyParams).then((smartyStreetsResult) => {
                    const addressFromGoogleFormat = pullAddressFromGoogleFormat(googlePlace);
                    $scope.liveAddressValue = combineGoogleAndSmartStreets(
                        addressFromGoogleFormat,
                        smartyStreetsResult
                    );

                    // put an error on the form. but use an unfamiliar key - because we don't want to show it..
                    ngModelCtrl.$setValidity(
                        'hiddenNeedApt',
                        !needApt() || alreadyGotApt() || !_.isEmpty(addressFromGoogleFormat.subpremise)
                    );

                    if (needApt() && !alreadyGotApt()) {
                        focusOnApt();
                    }

                    setPendingValidationValidity(true);
                    if (!isValidResult($scope.liveAddressValue)) {
                        return partialAddress(scope.address, addressFromGoogleFormat, lookupFromPartialText);
                    } else if (
                        isSubpremise(googlePlace) ||
                        isPremise(googlePlace) ||
                        !_.isEmpty(smartyStreetsResult.components)
                    ) {
                        $scope.sendEvent($scope.liveAddressValue, true);
                    } else {
                        return partialAddress(scope.address, addressFromGoogleFormat, lookupFromPartialText);
                    }
                });
            }

            const isValidResult = (liveAddressValue) => !_.isEmpty(liveAddressValue.city);

            const isSubpremise = ({ types }) => _.includes(types, 'subpremise');
            const isPremise = ({ types }) => _.includes(types, 'premise');
            const isStreetAddress = ({ types }) => _.includes(types, 'street_address');
            const isRoute = ({ types }) => _.includes(types, 'route');
            const isPartialAddress = (place) =>
                place.address_components && !isPremise(place) && !isStreetAddress(place) && isRoute(place);
            const shouldCheckWithSmartyStreet = (place) =>
                !$scope.field.ignoreSmartyStreet &&
                place.address_components &&
                (isPremise(place) || isStreetAddress(place) || isSubpremise(place));

            function checkAutocompleteGoogle(place) {
                setPendingValidationValidity(false);
                if (isPartialAddress(place)) {
                    return partialAddress(
                        scope.address,
                        pullAddressFromGoogleFormat(place),
                        place.lookupFromPartialText
                    );
                } else if (shouldCheckWithSmartyStreet(place)) {
                    return addSmartyStreets(place, place.lookupFromPartialText);
                } else {
                    return partialAddress(
                        scope.address,
                        pullAddressFromGoogleFormat(place),
                        place.lookupFromPartialText
                    );
                }
            }

            // guy - google maps can change the input value it seems
            // but we heavily rely on scope.address for everything else..
            // so we must keep them synced at all times.
            // this should be resolved when we implement 'deep' on address with unidirectional flow
            scope.$watch(
                () => element.find('[ng-model="address"]').val(),
                (newValue) => {
                    if (newValue && newValue !== scope.address) {
                        scope.address = newValue;
                    }
                }
            );

            const hasPlentyWords = (str) => str && /(\S+?) (\S+?) (\S+?) (\S+?)/.test(str);

            const lookupAddressInGoogle = function (placeStr) {
                ngModelCtrl.$setValidity('needApt', !needApt() || alreadyGotApt()); // TODO: find a better place for this
                setPendingValidationValidity(false);

                // place is being submitted without selecting something from google list
                // check we have a string and that the string has at least 4 words in it and that this isn't in a loop

                if ($scope.field.ignoreValidation !== true && hasPlentyWords(placeStr)) {
                    return convertStreetToPlace(placeStr, true).then(checkAutocompleteGoogle, function reject() {
                        // google could not find anything so pass back what was originally put in
                        partialAddress(placeStr, {}, {});
                    });
                } else if ($scope.field.ignoreValidation) {
                    $scope.sendInStreet(placeStr);
                } else {
                    ngModelCtrl.$setValidity('address', false);
                    $scope.liveAddressValue = undefined;
                    scope.sendEvent($scope.liveAddressValue);
                }
            };

            const inputInputLsr = function () {
                $scope.$apply(() => {
                    // all dom listeners should be wrapper in apply. also, fixes HIP-3082
                    origin = TEXT_ORIGIN;
                    lastSmartyStreetsResult = null;

                    // clear out validations on every change
                    ngModelCtrl.$setValidity('hiddenNeedApt', !needApt() || alreadyGotApt());
                    ngModelCtrl.$setValidity('address', true);
                    ngModelCtrl.$setValidity('required', true);
                    setPendingValidationValidity(false);

                    $scope.sendInStreet(scope.address);
                });
            };

            const inputKeyLsr = function (event) {
                $scope.$apply(function () {
                    const input = element.find('input');
                    const charCode = typeof event.which === 'number' ? event.which : event.keyCode;
                    if (charCode === 13) {
                        if ($window.$('.pac-item-selected').length === 0) {
                            lookupAddressInGoogle(scope.address);
                        }
                    }
                    if ((charCode === 40 || charCode === 38) && !scope.clearing) {
                        // arrow up and down!
                        scope.address = input[0].value;
                        origin = DROPDOWN_KEYBOARD_ORIGIN;
                    } else {
                        scope.clearing = false;
                    }
                });
            };

            scope.$on('runAddress', function (event, payload) {
                lookupAddressInGoogle(scope.address);
            });

            const inputBlurLsr = function (event) {
                event.target.style.textAlign = '';
                if (ngModelCtrl.$valid) {
                    return;
                }
                if (scope.field && scope.field.eventOnBlur) {
                    // wait to see if the field that took focus is our very own street 2
                    $timeout(() => {
                        if (document.activeElement !== element.find('input')[1]) {
                            lookupAddressInGoogle(scope.address);
                        }
                    });
                    element.removeClass('input-focused');
                }
            };
            const inputFocusLsr = function (event) {
                scope.needAptMsg = false;
                event.target.style.textAlign = 'left';
                if (scope.field && scope.field.eventOnBlur) {
                    element.addClass('input-focused');
                }
            };

            const initAutocomplete = function () {
                const input = element.find('input');
                if (input.length > 0) {
                    autocomplete = new $window.google.maps.places.Autocomplete(input[0], {
                        types: ['geocode'],
                        componentRestrictions: { country: 'us' }
                    });
                    // When the user selects an address from the dropdown, populate the address
                    // fields in the form.
                    autocompleteLsr = autocomplete.addListener('place_changed', function () {
                        // clear out validations on every change
                        ngModelCtrl.$setValidity('hiddenNeedApt', !needApt() || alreadyGotApt());
                        ngModelCtrl.$setValidity('address', true);
                        ngModelCtrl.$setValidity('required', true);
                        setPendingValidationValidity(false);
                        $timeout(function () {
                            if (scope.blurring && scope.clearing) {
                                scope.address = '';
                                scope.blurring = false;
                                clear();
                            } else {
                                const place = autocomplete.getPlace();
                                if (place.address_components) {
                                    // we got a geo place from google
                                    origin = DROPDOWN_CLICK_ORIGIN;
                                    checkAutocompleteGoogle(place, false);
                                } else {
                                    // google returned a stupid object with just name
                                    lookupAddressInGoogle(place.name);
                                }
                            }
                        }, 100);
                    });

                    input[0].addEventListener('input', inputInputLsr);
                    input[0].addEventListener('paste', inputInputLsr);
                    input[0].addEventListener('keyup', inputKeyLsr);
                    input[0].addEventListener('focus', inputFocusLsr);
                    input[0].addEventListener('blur', inputBlurLsr);
                    input[1].addEventListener('keyup', inputKeyLsr);
                    input[1].addEventListener('blur', inputBlurLsr);
                }
            };

            if ($window.google) {
                initAutocomplete();
            } else if ($window.googleCallbackDefer) {
                $window.googleCallbackDefer.promise.then(function () {
                    initAutocomplete();
                });
            } else if (!$window.googleCallbackDefer) {
                const defer = $q.defer();
                $window.googleCallbackDefer = defer;
                $window.googleCallbackDefer.promise.then(function () {
                    initAutocomplete();
                });
            }

            scope.$on('$destroy', function () {
                if ($window.google && $window.google.maps) {
                    $window.google.maps.event.removeListener(autocompleteLsr);
                    $window.google.maps.event.clearInstanceListeners(autocomplete);
                }
                $window.$('.pac-container').remove();
                const input = element.find('input');
                if (input.length > 0) {
                    input[0].removeEventListener('input', inputInputLsr);
                    input[0].removeEventListener('paste', inputInputLsr);
                    input[0].removeEventListener('keyup', inputKeyLsr);
                    input[0].removeEventListener('focus', inputFocusLsr);
                    input[0].removeEventListener('blur', inputBlurLsr);
                }
            });

            $timeout(
                function () {
                    if ($scope.field.mdlTextField) {
                        componentHandler.upgradeElements(element.find('.mdl-js-textfield')[0]);
                    }
                },
                0,
                false
            );
        }
    };
});
